import React from "react"

import { CHANGE_PAYMENT_METHOD } from "../../../../../../stores/CartStateStore"

export default function CashForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    maxChangeAmountCents,
    setCashAmount,
    cartState,
    dispatchCartState,
    enabled,
    errors,
    requiresCashValue,
    showAlertMessage,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleChange(event) {
    let value = event.target.value
    value = value.replace(",", ".") // Replace the commas with dots to support the decimal numbers
    value = value.replace(/[^0-9\.]+/g, "") // Replace non digits

    if (isNaN(parseFloat(value))) {
      value = ""
    }

    setCashAmount(value)

    dispatchCartState({
      type: CHANGE_PAYMENT_METHOD,
      payload: { type: "cash", options: { cash_amount: value || 0 } },
    })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  if (!enabled) {
    return <div>{I18n.t("cart_summary.venue_no_cash")}</div>
  }

  // -------------------------------------

  return (
    <div className="form-group fr-margin-top-large">
      {requiresCashValue && (
        <div>
          <p className="fr-p2 fr-normal">
            {I18n.t("cart_summary.cash_money_at_delivery_title")}
          </p>
          <div className="input-group">
            <span className="input-group-addon">€</span>
            <input
              type="text"
              className="form-control"
              name="cash_amount"
              value={cartState.paymentMethod.options?.cashAmount}
              onChange={handleChange}
            />
          </div>
        </div>
      )}

      {errors.payment_details &&
        errors.payment_details.map(function (error) {
          return <div className="help-block error">{error}</div>
        })}

      {showAlertMessage && (
        <p className="fr-p3 fr-italic fr-margin-top-small fr-margin-left-small">
          {I18n.t("cart_summary.cash_money_at_delivery", {
            value: maxChangeAmountCents / 100.0,
          })}
        </p>
      )}
    </div>
  )
}
